import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { BaseHttpService } from '@nimbus-library/features/shared/services/base-http/base-http.service';
import { IUserTasksCapacity } from '../../models/user-tasks-capacity.model';

@Injectable({ providedIn: 'root' })
export class UserTasksCapacityApiClient {
  public constructor(private readonly httpService: BaseHttpService) {}

  public getUserTasksCapacity(userId: string): Observable<IUserTasksCapacity> {
    return this.httpService.get(`facade/v1/portal/users/${encodeURIComponent(userId)}/task-capacity`);
  }
}
